import { IFileValidator } from "../../models/interfaces/file-validator.interface";

import { FileValidationRule } from "./file-validation-rule";

export class FileValidator implements IFileValidator {
  private rules: FileValidationRule;
  errorMessage: string | null = null;
  fileName = "";

  constructor() {
    this.rules = new FileValidationRule();
  }

  validate(file: File): boolean {
    this.errorMessage = null; // never leak the previous attempt's message

    if (!this.rules.isValidType(file)) {
      this.fileName = "";
      this.errorMessage = "fileTypeNotAllowed";
      return false;
    }

    if (!this.rules.isValidSize(file)) {
      this.errorMessage = "fileSizeExceedsLimit";
      return false;
    }

    return true;
  }
}
